<template>
  <BasePanelWithHeader headerText="Excise Transaction Type">
    <template v-slot:content>
      <v-row>
        <v-col cols="12" sm="auto">
          <v-switch v-model="showInactive" label="Show Inactive"></v-switch>
        </v-col>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="
              $refs.luExciseTransactionTypeForm.addLuExciseTransactionType()
            "
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Transaction Type
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="filteredLuExciseTransactionType"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{item}">
          <BaseTooltipButton
            small
            @click="
              $refs.luExciseTransactionTypeForm.editLuExciseTransactionType(
                item
              )
            "
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Transaction Type
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{item}">
          <BaseTooltipButton
            small
            @click="$refs.luExciseTransactionTypeDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Excise Transaction Type
          </BaseTooltipButton>
        </template>
        <template v-slot:item.IsActive="{item}">
          {{ item.IsActive ? 'Yes' : 'No' }}
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="luExciseTransactionTypeDelete"
        :delete="deleteLuExciseTransactionType"
        @refresh="clearLookupCacheAndReloadLuExciseTransactionType"
      >
        Are you sure you want to delete this excise transaction type?
      </BaseDeleteConfirm>
      <LuExciseTransactionTypeDialogForm
        ref="luExciseTransactionTypeForm"
        @refresh="clearLookupCacheAndReloadLuExciseTransactionType"
      >
      </LuExciseTransactionTypeDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import LuExciseTransactionTypeDialogForm from '@components/form/add-edit/LuExciseTransactionTypeDialog'
export default {
  components: {
    LuExciseTransactionTypeDialogForm,
  },
  data: () => ({
    searchText: '',
    showInactive: false,
  }),
  created() {
    this.loadLuExciseTransactionType()
  },
  computed: {
    ...get('luExciseTransactionType', ['luExciseTransactionType', 'loading']),
    filteredLuExciseTransactionType() {
      var list = this.luExciseTransactionType.filter((i) => true)
      if (!this.showInactive) {
        list = list.filter((i) => i.IsActive)
      }
      return list
    },
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Description',
          align: 'center',
          sortable: true,
          value: 'Description',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.showInactive,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luExciseTransactionType', [
      'deleteLuExciseTransactionType',
      'loadLuExciseTransactionType',
      'clearLookupCacheAndReloadLuExciseTransactionType',
    ]),
  },
}
</script>
<style></style>
